import { useState } from "react";

import {
  ServiceBay,
  ServiceBaySchedule,
} from "../../../../../../models/serviceBay";

import { ScheduleViewType } from "../..";
import Title from "./Title";
import Day from "./Day";
import Week from "./Week";
import Month from "./Month";
import { useMediaQuery } from "@mui/material";

interface IServiceBayScheduleProps {
  serviceBays: ServiceBay[];
  firstWeekDay: Date;
  lastWeekDay: Date;
  consultantMonthSchedule: ServiceBaySchedule[];
  currentDate: Date;
  setCurrentDate: (date: Date) => void;
  handleScheduleSidebar: () => void;
  scheduleViewType: ScheduleViewType;
  setScheduleViewType: (type: ScheduleViewType) => void;
  onCreateSchedule: () => void;
  setSchedule: (schedule: ServiceBaySchedule) => void;
  goToDate: (date: Date) => void;
}

const Schedule = (props: IServiceBayScheduleProps) => {
  const boxCount = props.serviceBays.length;
  const isResponsiveMobile = useMediaQuery("(max-width: 1024px)");

  const getBoxWidthClass = () => {
    if (boxCount === 1) return "w-full";
    return "w-1/2";
  };

  return (
    <div>
      <Title
        {...props}
        onCreateSchedule={props.onCreateSchedule}
        openScheduleModal={(schedule: ServiceBaySchedule) => {
          props.setSchedule(schedule);
          props.onCreateSchedule();
        }}
      />

      <div className={`flex ${isResponsiveMobile ? 'flex-col gap-4' : 'gap-2 flex-nowrap overflow-x-auto'} w-full`}>
        {props.serviceBays.map((serviceBay, index) => {
          const widthClass = isResponsiveMobile ? 'w-full' : getBoxWidthClass();
          return (
            <div
              key={index}
              className={`${widthClass} flex-shrink-0 flex flex-col border-t-2 border-r-8 p-8`}
            >
            <span className="text-[16px] font-semibold uppercase p-[10px]">
              {serviceBay.name}
            </span>

            {props.scheduleViewType === "month" && (
              <Month
                {...props}
                consultantMonthSchedule={props.consultantMonthSchedule.filter(
                  (schedule) => schedule.serviceBay?.id === serviceBay.id
                )}
                setCurrentDate={props.setCurrentDate}
                setScheduleViewType={props.setScheduleViewType}
              />
            )}

            {props.scheduleViewType === "week" && (
              <Week
                {...props}
                consultantMonthSchedule={props.consultantMonthSchedule.filter(
                  (schedule) => schedule.serviceBay?.id === serviceBay.id
                )}
                openScheduleModal={(schedule: ServiceBaySchedule) => {
                  props.setSchedule(schedule);
                  props.onCreateSchedule();
                }}
              />
            )}

            {props.scheduleViewType === "day" && (
              <Day
                {...props}
                consultantMonthSchedule={props.consultantMonthSchedule.filter(
                  (schedule) => schedule.serviceBay?.id === serviceBay.id
                )}
                openScheduleModal={(schedule: ServiceBaySchedule) => {
                  props.setSchedule(schedule);
                  props.onCreateSchedule();
                }}
              />
            )}
          </div>
          );
        })}
      </div>
    </div>
  );
};

export default Schedule;
